export const showInstallPrompt = () => {
  const prompt = document.createElement("div");
  prompt.setAttribute("class", "newVersionPrompt");
  prompt.innerHTML = `
    <div class="content">
        <h1>New Version Available!</h1>
        <h2>The app was updated to the latest version. Press the button to start using the update.</h2>
        <button onclick="window.location.reload()">Update</button>
    </div>
  `;
  document.querySelector("body").appendChild(prompt);
};
